import React from "react"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select"

interface AgeGroupSelectProps {
    value?: string
    onValueChange: (value: string) => void
}

export const AgeGroupSelect: React.FC<AgeGroupSelectProps> = ({
    value = "all",
    onValueChange,
}) => {
    return (
        <Select onValueChange={onValueChange} defaultValue={value}>
            <SelectTrigger className="w-[180px] rounded-full">
                <SelectValue placeholder="All Age Groups" />
            </SelectTrigger>
            <SelectContent className="z-[102]">
                <SelectItem value="all">All Age Groups</SelectItem>
                <SelectItem value="Youth">Youth</SelectItem>
                <SelectItem value="Elderly">Elderly</SelectItem>
                <SelectItem value="Youth and Elderly">
                    Youth and Elderly
                </SelectItem>
            </SelectContent>
        </Select>
    )
}
